import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef } from "ngx-bootstrap/modal";

import { UserProduct } from "@shared/Interfaces/user-products.interface";

@Component({
  selector: "app-modal-dahsboard-select",
  templateUrl: "./modal-dashboard-select.html",
  styleUrls: ["./modal-dashboard-select.component.scss"],
})
export class ModalDashboardSelectComponent implements OnInit {
  @Input() public OptionArray: UserProduct[];
  @Input() public IsFromConfiguration: boolean = false;
  public selectDashboardBind: string = "";

  constructor(private bsModalRef: BsModalRef, private router: Router) {}

  public ngOnInit(): void {
    const currentSelection = localStorage.getItem("selectedDashboard");
    if (currentSelection) {
      this.selectDashboardBind = currentSelection;
    } else {
      this.selectDashboardBind = this.OptionArray[0]?.url;
    }
  }

  public saveSelection(): void {
    localStorage.setItem("selectedDashboard", this.selectDashboardBind);
    localStorage.removeItem("dashboardModalOpen");
    this.bsModalRef.hide();
    this.router.navigateByUrl(this.selectDashboardBind);
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
